<IziGrid class="filter-chanllenge-container">
  <IziCol class="search-challenge" xl="12">
    <IziInput class="search p-card" icon="pi-search" iconPos="left" label="Enter Challenge Name"
      v-model:value="keySearch" />
  </IziCol>
  <IziCol class="filter-challenge">
    <div class="title">
      <IziIcon>watch_later</IziIcon>
      <span>Challenge by Length</span>
    </div>
  </IziCol>
  <IziCol class="type" v-for="(type, index) of types" :key="index">
    <ToggleButton v-model="type.value" @click="setkeyFilter(type)" :onLabel="type.name + ' minutes'"
    :offLabel="type.name + ' minutes'" />
  </IziCol>
</IziGrid>